import {Image, Page, Text, View} from '@react-pdf/renderer';
import React from 'react';
import {styles} from '../styles';

import sleipnerBackground from 'assets/pdf/sleipner-pdf-bg.png';
import sleipnerLogo from 'assets/logo.png';
import {Footer} from '../Footer';
import {CustomerDetails} from '../CustomerDetails';
import {TableRowTwoCol as TableRow} from '../documentComponents';
import {formatCurrency, baseFormatClean} from 'components/ModelDetailsTable';
import {yellow} from 'styles/constants';

export const CoverPage = ({
	customer,
	showellUser,
	recommendedSleipner,
	calculatedValues,
}) => {
	return (
		<Page size="A4" style={styles.layout.page}>
			{/* header background image */}
			<Image src={sleipnerBackground} style={styles.image.pageBackground} />

			<View
				style={[styles.layout.containerHorizontal, {paddingTop: 29, paddingBottom: 29}]}
			>
				<View style={[styles.layout.flexContainer]}>
					<Image src={sleipnerLogo} style={styles.image.sleipnerTopLogo} />
					<CustomerDetails customer={customer} />
				</View>

				<View>
					<Text style={[styles.text.subHeading]}> </Text>
					<Text style={[styles.text.heading]}>Your benefit,</Text>
					<Text style={[styles.text.heading, {position: 'relative', top: '-15px'}]}>
						our commitment
					</Text>
				</View>
			</View>

			{/* Recommended sleipner image */}
			<Image
				src={recommendedSleipner.coverImageUrl}
				style={[{width: '100%', height: '300px', marginTop: '-40px'}]}
			/>

			{/* footer background image */}
			<Image
				src={sleipnerBackground}
				style={[styles.image.pageBackground, {bottom: 0, left: 0, right: 0, height: 340}]}
			/>

			<View style={[styles.layout.container, {marginTop: '-150px'}]}>
				<View
					style={{
						backgroundColor: 'rgba(0,0,0,0.4)',
						borderRadius: '5px',
						padding: '18px',
					}}
				>
					<Text style={[styles.text.heading]}>{recommendedSleipner.model}</Text>
					<Text style={[styles.text.white]}>
						Why pay for an entire trailer when you just need the wheels? Sleipner E Series
						dollies put your excavator on roller skates, replacing slow and shaky tramming
						with a fast, smooth ride on rubber wheels. This means up to 85% less time used
						for on-site transits and more time for productive work.
					</Text>
					<Text style={[styles.text.white, {marginTop: '16px'}]}>
						The Sleipner Benefit Calculator lets you specify individual resource options
						and displays the benefits to your mine instantly. Here are just some of the
						values that Sleipner can calculate for you. Turn the page and see all the
						values produced by the calculator.
					</Text>
					<View style={{marginTop: '16px', color: yellow}}>
						<Text style={{fontWeight: 'bold', marginBottom: '5px'}}>Key benefits</Text>
						<TableRow title="Annual production increase" noBorder>
							{formatCurrency(calculatedValues['Production increase ($)'])}
						</TableRow>
						<TableRow title="Lifetime savings in undercarriage rebuilds" noBorder>
							{formatCurrency(
								calculatedValues['Lifetime undercarriage rebuild part savings ($)'],
							)}
						</TableRow>
						<TableRow title="Lifetime reduction in CO2 emissions" noBorder>
							{`${baseFormatClean(
								calculatedValues['CO2 reduction with Sleipner in lifetime (tonnes)'],
							)} tonnes`}
						</TableRow>
						<TableRow title="Payback time" noBorder>
							{`${baseFormatClean(
								calculatedValues['Investment payback time (month)'],
							)} months`}
						</TableRow>
					</View>
				</View>
			</View>
			<Footer showellUser={showellUser} />
		</Page>
	);
};
